import { useSelector } from "react-redux";

export const useLanguage = () => {
  const language = useSelector((state) => state.Settings.language || {});

  const t = (key) => {
    if (!key) return "";

    const keys = key.split("."); // split by dot for nested keys
    let value = language;

    for (let k of keys) {
      value = value?.[k];
      if (value === undefined) return key; // fallback to the key itself if missing
    }

    return value;
  };

  return t;
};
